<template>
  <main class="carousel-campaign">
    <swiper slides-per-view="auto"
            :navigation="swiperNavigation"
            :pagination="swiperPagination"
            :observer="true"
            :observe-parents="true"
            :grab-cursor="true"
            :centered-slides="false"
            id="carousel-campaign"
            @swiper="onSwiper">
      <swiper-slide v-for="(slide, index) of slides"
                    :key="slide.id"
                    class="w-8/12"
                    :class="{'w-full': slides.length === 1}">
        <!--video slide-->
        <div class="img-container m-0 w-full pb-2 flex items-end justify-center w-full" v-if="slide.media_type == 'video'">
          <div
              class="z-20 counter bg-white absolute top-1 right-1 rounded-full border border-solid flex items-center justify-around absolute top-1 right-1 z-10">
            <div class="icon text-blue cursor-pointer prev-btn-campaign-carousel" @click="stopAllVideo">
              <fai :icon="['fas', 'chevron-left']"/>
            </div>
            <div class="number text-xs px-1">
              {{ index + 1 }}
            </div>
            <div class="icon text-blue cursor-pointer next-btn-campaign-carousel" @click="stopAllVideo">
              <fai :icon="['fas', 'chevron-right']"/>
            </div>
          </div>
          <!--your tube Iframe-->
          <template v-if="slide.url && slide.media_type == 'video'">
            <div class="z-10 absolute inset-x-0 h-2/5 top-0 transparent"></div>
            <div class="z-10 absolute inset-y-0 w-2/5 right-0 bottom-14 transparent"></div>
            <div class="z-10 absolute inset-x-0 h-1/4 bottom-12 transparent"></div>
            <div class="z-10 absolute inset-y-0 w-2/5 left-0 bottom-14 transparent"></div>
            <iframe :src="slide.result_url"
                    class="w-full min-h-full absolute"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
            />
          </template>
          <!--custom player-->
          <div v-else-if="!slide.url && slide.media_type == 'video'"
               class="video">
            <video-player
                class="campaign-video"
                :uniqID="`campaign-video-preview_${index}`"
                :ref="`campaign-video-preview_${index}`"
                :src="slide.result_url"/>
          </div>
          <div
              class="remove-action bottom-4 border border-solid py-2 px-3 rounded cursor-pointer block absolute left-1/2 z-10"
              @click="$emit('remove-slide', slide)">remove
          </div>
        </div>
        <!--image container -->
        <div class="img-container m-0 w-full bg-cover bg-center bg-no-repeat flex items-end justify-center pb-2"
             v-else
             :style="`background-image: url(${slide.result_url})`">
          <div
              class="counter bg-white absolute top-1 right-1 rounded-full border border-solid flex items-center justify-around">
            <div class="icon text-blue cursor-pointer prev-btn-campaign-carousel" @click="stopAllVideo">
              <fai :icon="['fas', 'chevron-left']"/>
            </div>
            <div class="number text-xs px-1">
              {{ index + 1 }}
            </div>
            <div class="icon text-blue cursor-pointer next-btn-campaign-carousel" @click="stopAllVideo">
              <fai :icon="['fas', 'chevron-right']"/>
            </div>
          </div>
          <div class="remove-action bottom-4 border border-solid py-2 px-3 rounded cursor-pointer"
               @click="$emit('remove-slide', slide)">remove
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </main>
</template>

<script>
import Vue from 'vue';
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import VideoPlayer from '../../shared/video-player'
import {mapGetters} from "vuex";

SwiperCore.use([Navigation, Pagination])

export default {
  name: 'CarouselCampaign',
  props: {
    slides: Array
  },
  components: {
    Swiper,
    SwiperSlide,
    VideoPlayer
  },
  data: () => ({
    swiper: null,
  }),
  computed: {
    swiperNavigation() {
      return {
        nextEl: '.next-btn-campaign-carousel',
        prevEl: '.prev-btn-campaign-carousel'
      }
    },
    swiperPagination() {
      return {
        el: `.swiper-pagination-campaign-${this.stashboardCommunicationType}`,
        type: "fraction"
      }
    },
    ...mapGetters([
      'stashboardCommunicationType',
      'focusedStashboardMedia'
    ])
  },
  mounted() {
    this.swiper.slideTo(this.slides.length - 1, 0)
  },
  watch: {
    async slides(newSlides) {
      // this line waits for the swiper to receive the new slides, otherwise the slideTo has no effect
      setTimeout(() => {
        this.swiper.slideTo(newSlides.length - 1, 0)
      }, 0);
    },
    focusedStashboardMedia(sm) {
      this.focusSlide(sm)
    }
  },
  methods: {
    async focusSlide(slide) {
      const idx = _.indexOf(this.slides, slide)
      setTimeout(() => {
        this.swiper.slideTo(idx, 0)
      }, 0);
    },

    stopAllVideo() {
      const videos = document.querySelectorAll('.campaign-video > video')
      if (videos) {
        videos.forEach(el => {
          const id = el.getAttribute('id') || ''
          const ref = this.$refs[id]
          ref[0].pauseVideo()
          ref[0]._data.videoToggle = false
        })
      }
    },

    onSwiper(swiper) {
      this.swiper = swiper
    }
  }
}
</script>

<style scoped>
.img-container {
  height: 350px;
}

.remove-action {
  transform: translateX(-50%);
}

.counter {
  width: 40px;
  height: 40px;
}

.icon svg {
  width: 6px;
}

.swiper-button-disabled {
  opacity: 0.25;
  pointer-events: none;
  display: block !important;
}
</style>
